
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-gray-800 bg-[#0a0c1b] py-6">
      <div className="container-padding">
        <div className="flex flex-col items-center justify-center space-y-4">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} RaiseLaunch, LLC DBA RaiseSpark. All rights reserved.
          </p>
          
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-xs text-gray-400 hover:text-gray-200 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-xs text-gray-400 hover:text-gray-200 transition-colors">
              Terms of Service
            </Link>
          </div>
          
          <div className="mt-4 pt-4 border-t border-gray-800 w-full max-w-2xl">
            <p className="text-xs text-gray-400 text-center">
              RaiseSpark was designed and developed by the RaiseSpark team. 
              Have an idea for an app or web platform, especially focused on AI? 
              <Link to="/contact-us" className="text-indigo-400 hover:text-indigo-300 ml-1 transition-colors">
                We can build it for you.
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
